import React from 'react';
import NotifyMe from "v4/components/utils/NotifyMe/NotifyMe";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import Table from "v4/components/ui/Table/Table";
import SearchContextPagination from "v4/components/utils/SearchContextPagination/SearchContextPagination";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import ValidateImportFormTableRow
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTableRow/ValidateImportFormTableRow";
import useImportTable from "v4/pages/admin/Import/components/ImportSteps/hooks/useImportTable";
import useValidateImportFormTable
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTable/hooks/useValidateImportFormTable";
import ImportRowsInfos
    from "v4/pages/admin/Import/components/ImportSteps/components/ImportRowsInfos/ImportRowsInfos";
import Confirm from "v4/components/ui/Confirm/Confirm";
import {IMPORT_MAPPING_RESULT_DATA, IMPORT_MAPPING_RESULT_SEARCH_FORM} from "v4/data/apiRoutes";
import ImportTableProvider from "v4/pages/admin/Import/contexts/ImportTableContext";
import ValidateImportExportButton
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTable/components/ValidateImportExportButton/ValidateImportExportButton";
import ValidateImportFormFilters
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateImport/components/ValidateImportFormTable/components/ValidateImportFormFilters/ValidateImportFormFilters";

export default function ValidateImportFormTable({isProcessing}) {
    const {t} = usePolTranslation();
    const {
        isTableLoading,
        tableHeaders,
        tableRows,
        fullData,
        methods,
        searchFormData,
        onSort,
        onRowsStatusSort,
        onExportDownload,
        getSortableFieldName,
        getSortableFieldValues,
    } = useImportTable(IMPORT_MAPPING_RESULT_DATA, IMPORT_MAPPING_RESULT_SEARCH_FORM);
    const {
        theadData,
        startImport,
        isOpen,
        toggleIsOpen,
    } = useValidateImportFormTable(tableHeaders);

    return (
        <ImportTableProvider {...{onRowsStatusSort, onExportDownload, getSortableFieldName, getSortableFieldValues}}>
            <div className="import-table__extras">
                <ImportRowsInfos fullData={fullData}/>

                <div className="import-table__extras__table-actions">
                    {!isProcessing && (
                        <div className="import-table__extras__table-actions__btns">
                            <NotifyMe tipPlacement="left"/>

                            <ValidateImportExportButton/>

                            <SubmitButton onClick={toggleIsOpen}>
                                {t('import')}
                            </SubmitButton>
                        </div>
                    )}

                    <SearchContextPagination canChangeItemsPerPage={false}
                                             showWrapperEvenIfNoPages/>
                </div>
            </div>

            {(fullData && searchFormData?.['hydra:member']) && (
                <>
                    <div className="import-table__infos-filters">
                        <p>{t('filtered_rows_displaying', {current: fullData.data.length, total: fullData.totalFilteredItems})}</p>
                        <ValidateImportFormFilters searchFormData={searchFormData} methods={methods}/>
                    </div>
                </>
            )}

            <div className="import-table__overflow">
                <Table className="import-table"
                       onSort={onSort}
                       isLoading={isTableLoading}
                       theadData={theadData}
                       tableRows={tableRows}
                       renderRow={(rowData, index) => (
                           <ValidateImportFormTableRow key={index}
                                                       headers={theadData}
                                                       rowData={rowData}
                                                       index={index}
                           />
                       )}
                />
            </div>

            <div className="import-table__extras__table-actions">
                <SearchContextPagination canChangeItemsPerPage={false}
                                         showWrapperEvenIfNoPages/>
            </div>


            <Confirm title={t('confirm')}
                     isOpen={isOpen}
                     cancelAction={toggleIsOpen}
                     confirmAction={startImport}
                     yesLabel={t('import')}
                     noLabel={t('cancel')}>
                <p>{fullData?.totalNotValidatedItems > 0
                    ? t('import_with_errors_confirm_message')
                    : t('import_confirm_message')
                }</p>
            </Confirm>
        </ImportTableProvider>
    )
}
